export const getVoidCityNpcDialogue = (npcName) => {
  const dialogues = {
    receptionist: {
      greetings: [
        "Welcome, challenger! Ready to face some foes?",
        "Hey there! Wanna create a room or join the action?",
        "👋 Looking to battle? I can help you get set up.",
        "Back again? Let’s get you into a room.",
        "The arena awaits. What would you like to do?",
      ],
      options: ["Create Room", "Join Room", "Nevermind"],
    },
    merchant: {
      greetings: [
        "Ah, a customer! What are you looking for today?",
        "Welcome! Got goods to trade or tokens to spend?",
        "Need supplies? I’ve got what you need.",
        "Let’s make a deal. You buying or selling?",
        "Looking for something rare?",
      ],
      options: ["Shop", "Sell", "Nevermind"],
    },
    decksmith: {
      greetings: [
        "The right deck makes the difference. How can I help?",
        "You here to forge a new deck?",
        "Ready to sharpen your strategy?",
        "Let’s craft something powerful.",
        "Time to make some card magic?",
      ],
      options: ["Craft a Deck", "Nevermind"],
    },
    questmaster: {
      greetings: [
        // "Greetings, traveler. Seeking adventure? Just take a look at the quest boards.",
        // "You look like you could handle a task or two. We've got plent on the boards.",
        // "Need a quest? I’ve got a few for you on the quest boards.",
        // "Looking to earn some glory? Take a look at the quests.",
        // "There’s always work for the brave.",
        "No quests for you today, come back later.",
      ],
      options: ["Okay", "Nevermind"],
    },
    voidcityfrog: {
      greetings: [
        "Ribbit...",
        "Uhh, ribbit ribbit",
        "Ribbit ribbit ribbit",
        ".... Shhhhh",
        "Maybe I should go back to the pond.",
      ],
      options: ["Okay"],
    },
    questboard1: {
      greetings: [
        "Hmmm there are a lot of quests here, which one do I want to do?",
        "I have a lot of quests here, what to do?",
        "Time for another adventure!",
      ],
      options: ["Choose Quests", "Nevermind"],
    },
    questboard2: {
      greetings: [
        "Hmmm there are a lot of quests here, which one do I want to do?",
        "I have a lot of quests here, what to do?",
        "Time for another adventure!",
      ],
      options: ["Choose Quests", "Nevermind"],
    },
  };

  const npc = dialogues[npcName];
  if (!npc) return null;

  const randomGreeting =
    npc.greetings[Math.floor(Math.random() * npc.greetings.length)];

  console.log("randomGreeting", { text: randomGreeting, options: npc.options });
  return {
    text: randomGreeting,
    options: npc.options,
  };
};
